import type { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

/**
 * Components passed to react-markdown. Anchors open in a new tab with
 * `rel="noopener noreferrer"` — agent replies frequently cite URLs. Code
 * blocks render through the default `<pre><code>` pair; the consumer's CSS
 * handles the look.
 */
const markdownComponents = {
  a: (props: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
}

export interface MarkdownMessageProps {
  content: string
  className?: string
}

/**
 * Single markdown renderer for agent/AI message bodies. Used by the sidebar
 * live item, the streaming popup, and any future message surface — one
 * renderer means one look for the same bytes. During streaming, callers
 * re-render on every chunk; partial fences/lists render best-effort and
 * stabilise once the closing chunk arrives.
 */
export const MarkdownMessage: FC<MarkdownMessageProps> = props => {
  const { content, className } = props
  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {content}
      </ReactMarkdown>
    </div>
  )
}
